export default {
  direct: 'Direct',
  stops: 'tussenstops',
  stop: 'tussenstop',
}
